/*
 * en-us locale
 * @ignore
 * @author yiminghe@gmail.com
 */
"use strict";

module.exports = {
  // in minutes
  timezoneOffset: -8 * 60,
  firstDayOfWeek: 0,
  minimalDaysInFirstWeek: 1
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/gregorian-calendar/lib/locale/en_US.js
 ** module id = 825
 ** module chunks = 0
 **/